import React, { useState } from 'react'
import {
  CCard,
  CCardHeader,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { DemoContestForm } from '../widgets/DemoContestForm/component'
import { TextsSettingForm } from '../widgets/TextsSettingForm/component'
import { ImageSettingsForm } from '../widgets/ImageSettingsForm/component'

export const EditDemoContest = () => {
  const [activeClientTab, setActiveClientTab] = useState(1)

  return (
    <CCard className="mb-4">
      <CCardHeader>
        <strong>Edit Demo contest</strong>
      </CCardHeader>
      <CNav variant="tabs" role="tablist" className="mt-2">
        <CNavItem>
          <CNavLink
            data-tab="demoContest"
            href="#!"
            active={activeClientTab === 1}
            onClick={() => setActiveClientTab(1)}
          >
            Demo contest
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink
            data-tab="content"
            href="#!"
            active={activeClientTab === 2}
            onClick={() => setActiveClientTab(2)}
          >
            Content
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink
            data-tab="images"
            href="#!"
            active={activeClientTab === 3}
            onClick={() => setActiveClientTab(3)}
          >
            Images
          </CNavLink>
        </CNavItem>
      </CNav>
      <CTabContent className="pt-3">
        <CTabPane
          data-tab="demoContest"
          role="tabpanel"
          visible={activeClientTab === 1}
        >
          <DemoContestForm mode="edit" />
        </CTabPane>
        <CTabPane
          data-tab="contentSetting"
          role="tabpanel"
          visible={activeClientTab === 2}
        >
          <TextsSettingForm mode="edit" />
        </CTabPane>
        <CTabPane
          data-tab="imageSetting"
          role="tabpanel"
          visible={activeClientTab === 3}
        >
          <ImageSettingsForm mode="edit" />
        </CTabPane>
      </CTabContent>
    </CCard>
  )
}
